// components/ReactivacionWizard.jsx
import { useEffect, useMemo, useState } from "react";
import { Modal, Button, Form, Badge } from "react-bootstrap";

export default function ReactivacionWizard({
                                               open,
                                               onClose,
                                               selected,               // { SolicitudId, rol_id, foto_url, ... }
                                               onConfirm,              // ({ telco, red, toa }) => void
                                               initialSelections,      // opcional: { telco?: boolean, red?: boolean, toa?: boolean }
                                           }) {
    const [step, setStep] = useState(1);
    const [telco, setTelco] = useState(false);
    const [red, setRed]     = useState(false);
    const [toa, setToa]     = useState(false);

    // rol 9 puede TOA
    const canToa = Number(selected?.rol_id) === 9;

    useEffect(() => {
        setStep(1);
        setTelco(!!initialSelections?.telco);
        setRed(!!initialSelections?.red);
        setToa(canToa && !!initialSelections?.toa);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open, selected?.SolicitudId]);

    const canAccept = useMemo(
        () => telco || red || (canToa && toa),
        [telco, red, toa, canToa]
    );

    const handleClose = () => {
        onClose?.();
    };

    const handleNext = () => setStep(2);
    const handleBack = () => setStep(1);

    const handleAccept = () => {
        if (!canAccept) return;
        onConfirm?.({ telco, red, toa: canToa ? toa : false });
        handleClose();
    };

    return (
        <Modal show={open} onHide={handleClose} size="lg" centered backdrop="static">
            <Modal.Header closeButton>
                <Modal.Title>
                    Reactivación de Solicitud #{selected?.SolicitudId}{" "}
                    <Badge bg="secondary" className="ms-2">Paso {step} de 2</Badge>
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>

                {step === 1 && (
                    <div className="text-center">
                        <p className="mb-4 fw-semibold">
                            ¿Revisaste con tus supervisores que este usuario no esté bloqueado?
                        </p>
                        <div className="d-flex justify-content-center gap-3">
                            <Button variant="success" onClick={handleNext}>
                                Sí, continuar
                            </Button>
                            <Button variant="outline-secondary" onClick={handleClose}>
                                No / Cerrar
                            </Button>
                        </div>
                    </div>
                )}

                {step === 2 && (
                    <>
                        <p className="fw-semibold text-center mb-3">¿Qué deseas reactivar?</p>
                        <div className="d-grid gap-2" style={{ maxWidth: 420, margin: "0 auto" }}>
                            <Form.Check
                                type="checkbox"
                                id="reactivar-telco"
                                label="Siebel Telco"
                                checked={telco}
                                onChange={() => setTelco((v) => !v)}
                            />
                            {canToa && (
                                <Form.Check
                                    type="checkbox"
                                    id="reactivar-toa"
                                    label="TOA"
                                    checked={toa}
                                    onChange={() => setToa((v) => !v)}
                                />
                            )}
                            <Form.Check
                                type="checkbox"
                                id="reactivar-red"
                                label="Usuario Red"
                                checked={red}
                                onChange={() => setRed((v) => !v)}
                            />
                        </div>
                    </>
                )}
            </Modal.Body>

            <Modal.Footer className="d-flex justify-content-between">
                {step === 2 ? (
                    <>
                        <Button variant="outline-secondary" onClick={handleBack}>
                            Volver
                        </Button>
                        <div>
                            <Button variant="secondary" className="me-2" onClick={handleClose}>
                                Cancelar
                            </Button>
                            <Button variant="success" onClick={handleAccept} disabled={!canAccept}>
                                Aceptar
                            </Button>
                        </div>
                    </>
                ) : (
                    <>
                        <div />
                        <Button variant="secondary" onClick={handleClose}>
                            Cerrar
                        </Button>
                    </>
                )}
            </Modal.Footer>
        </Modal>
    );
}
